"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInput = exports.validateDate = void 0;
var _constants = require("./constants");
/**
 * Returns true if the month is between 1 and 12
 *
 * @param {String} month The current value of month from state
 * @returns {Boolean}
 */
const validateMonth = month => {
  const monthNum = Number(month);
  return 1 <= monthNum && monthNum <= 12;
};

/**
 * Returns true if the day is between 1 and 31
 *
 * @param {String} day The current value of day from state
 * @returns {Boolean}
 */
const validateDay = day => {
  const dayNum = Number(day);
  return 1 <= dayNum && dayNum <= 31;
};

/**
 * Returns true if the year is greater the 999
 *
 * @todo Any additional, default validation for year?
 * @param {String} year The current value of year from state
 * @returns {Boolean}
 */
const validateYear = year => {
  const yearNum = Number(year);
  return yearNum > 999;
};

/**
 * Returns true if the given day is valid for the given month
 *
 * @param {String} month The current value of month from state
 * @param {String} day The current value of day from state
 * @returns {Boolean}
 */
const validateDayForMonth = (month, day) => {
  const monthNum = Number(month);
  const dayNum = Number(day);
  if (!validateMonth(month) || !validateDay(day)) {
    return false;
  } else if (monthNum === 2) {
    return 1 <= dayNum && dayNum <= 29;
  } else if (monthNum === 4 || monthNum === 6 || monthNum === 9 || monthNum === 11) {
    return 1 <= dayNum && dayNum <= 30;
  } else {
    return 1 <= dayNum && dayNum <= 31;
  }
};

/**
 * Returns true if we can build a valid date with the current values
 * in state according to our internal validation rules.
 *
 * @param {String} month The current value of month from state
 * @param {String} day The current value of day from state
 * @param {String} year The current value of year from state
 * @returns {Boolean}
 */
const validateDate = (month, day, year) => {
  return validateYear(year) && validateDayForMonth(month, day);
};

/**
 * This function validates a value based on its type (one of MONTH, DAY, or YEAR).
 * It does not handle missing required fields, that is handled down in the components
 * where the error messages are actually added to the state. This simply validates
 * an existing value and return a boolean.
 *
 * @param {String} inputType One of [MONTH, DAY, YEAR], pulled from constants
 * @param {String} value The value that is being validated
 * @returns {Boolean} True if validation passes, otherwise false
 */
exports.validateDate = validateDate;
const validateInput = (inputType, value) => {
  if (!value || value === '') {
    return true;
  }
  switch (inputType) {
    case _constants.INPUT_TYPE_MONTH:
      return validateMonth(value);
    case _constants.INPUT_TYPE_DAY:
      return validateDay(value);
    case _constants.INPUT_TYPE_YEAR:
      return validateYear(value);
    default:
      return true;
  }
};
exports.validateInput = validateInput;